/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableExpansionTemplate } from 'src/app/@amiga-pyme/table-expansion/templates/table-expansion.template';
import {
  IProductOfProvider,
  PRODUCTS_OF_PROVIDER_TTL_ES
} from 'src/app/pages/gestion/products-of-provider/products-of-provider.interface';
import { ProductsOfProviderService } from 'src/app/pages/gestion/products-of-provider/products-of-provider.service';

@Component({
  selector: 'pg-products-provider',
  templateUrl: './products-provider.component.html',
  providers: [MessageService]
})
export class ProductsProviderComponent extends TableExpansionTemplate {
  @Input() providerId: number;
  @Input() items;
  @Input() isInvoice: boolean;
  productsSelected: unknown[];
  openSideBar = false;
  itemToSideBar: any;
  filteredTableData: any[];
  itemReceptionToSidebar: any;
  itemInvoiceToSidebar: any;
  constructor(private productsOfProviderBase: ProductsOfProviderService) {
    super('', productsOfProviderBase);
  }

  ngOnChanges(changes: any) {
    if (changes.providerId) {
      this.providerId = changes.providerId.currentValue;
      this.initSubscriptions$();
    }

    if (this.items) {
      if (this.isInvoice) {
        this.table.settings = {
          title: PRODUCTS_OF_PROVIDER_TTL_ES,
          columns: [
            { header: 'Descripción', field: 'name' },
            { header: 'Cantidad', field: 'quantity' },
            { header: 'Cant. Facturada', field: 'quantity_invoiced' }
          ]
          //
        };
        this.table.actions = [
          {
            name: 'add-product-cart-invoice',
            icon: 'pi pi-plus',
            class: 'p-button-rounded p-button-info mr-2',
            pTooltip: 'Agregar Productos Facturados'
          }
        ];
      } else {
        this.table.settings = {
          title: PRODUCTS_OF_PROVIDER_TTL_ES,
          columns: [
            { header: 'Descripción', field: 'name' },
            { header: 'Unidad de medida', field: 'unitMeasure' },
            { header: 'Cantidad', field: 'quantity' },
            { header: 'Cant. Recibida', field: 'quantity_received' },
            { header: 'Cant. Rechazada', field: 'quantity_rejected' }
          ]
          //
        };

        this.table.actions = [
          {
            name: 'add-product-cart-reception',
            icon: 'pi pi-plus',
            class: 'p-button-rounded p-button-info mr-2',
            pTooltip: 'Agregar Productos a Recepción'
          }
        ];
      }
    }

    if (this.providerId) {
      this.table.settings = {
        title: PRODUCTS_OF_PROVIDER_TTL_ES,
        columns: [
          { header: 'Proveedor', field: 'providerName' },
          { header: 'Unidad de medida', field: 'unitMeasureDescription' },
          { header: 'Código', field: 'code' },
          { header: 'Descripción', field: 'description' }
        ]
        //
      };
      this.table.actions = [
        {
          name: 'add-product-cart-sale',
          icon: 'pi pi-plus',
          class: 'p-button-rounded p-button-info mr-2',
          pTooltip: 'Agregar Producto'
        }
      ];
    }

    this.initSubscriptions$();
  }

  initSubscriptions$() {
    if (this.items) {
      this.table.data = this.items;
    }
    if (this.providerId) {
      this.suscriptionBase$ = this.productsOfProviderBase
        .getData$()
        .subscribe((data: IProductOfProvider[]) => {
          this.table.data = data.filter(
            (row) => row.providerId === this.providerId
          );
          this.filteredTableData = [...this.table.data];
        });
    }
  }

  // ngOnDestroy() {
  //   this.unsubscribeBase();
  // }

  onReciveAction(event): void {
    const { action, data } = event;
    if (action === 'add-product-cart-sale') {
      this.itemToSideBar = data;
      this.openSideBar = true;
    }
    if (action === 'add-product-cart-reception') {
      this.itemReceptionToSidebar = data;
      this.openSideBar = true;
    }

    if (action === 'add-product-cart-invoice') {
      this.itemInvoiceToSidebar = data;
      this.openSideBar = true;
    }
  }

  onCloseSideBar() {
    this.openSideBar = false;
  }

  onItemToSideBar(event) {
    const { data } = event;
    if (data) {
      this.itemToSideBar = event.data;
      this.openSideBar = true;
    }
  }
  clearFilter() {
    this.filteredTableData = [...this.table.data];
  }
}
